import { useEffect } from "react";

import thaiData from "../../../thai-data.json";

const useThailandAddress = formik => {
  const data = thaiData;

  const getZipCode = (
    selectedProvince,
    selectedDistrict,
    selectedSubDistrict
  ) => {
    const location = data.find(
      item =>
        item?.provinceList?.[0]?.provinceName === selectedProvince &&
        item?.subDistrictList?.find(
          subDistrict =>
            subDistrict?.subDistrictName === selectedSubDistrict &&
            item?.districtList?.find(
              district => district?.districtName === selectedDistrict
            )
        )
    );

    return location ? location?.zipCode : null;
  };
  const selectedProvince = formik?.values?.city.replace(/^จ\.\s*/, "");

  const mapValueGenerateLabe = (value, type) => {
    const isBKK = selectedProvince === "กรุงเทพมหานคร";
    switch (type) {
      case "city":
        // Check if the value === 'กรุงเทพมหานคร' because when initializing, formik.values.city does not have a value yet
        return value === "กรุงเทพมหานคร" ? value : `จ. ${value}`;
      case "district":
        return isBKK ? `เขต ${value}` : `อ. ${value}`;
      case "subDistrict":
        return isBKK ? `แขวง ${value}` : `ต. ${value}`;
      default:
        return value;
    }
  };

  const generateLabelValue = (rawData, type) =>
    Array.from(rawData).map((item: string) => ({
      label: item,
      value: mapValueGenerateLabe(item, type)
    }));

  const zipCodeSet = new Set(
    data
      .filter(item => item?.subDistrictList?.[0])
      .map(item => item?.zipCode)
      .filter(zipCode => zipCode)
  );
  const zipCode = generateLabelValue(zipCodeSet, "").sort(
    (a, b) => parseInt(a.label, 10) - parseInt(b.label, 10)
  );

  const provinceSet = new Set(
    data
      .filter(item => item?.provinceList?.[0])
      .map(item => item?.provinceList?.[0]?.provinceName)
      .filter(province => province)
  );
  const city = generateLabelValue(provinceSet, "city").sort((a, b) =>
    a.label.localeCompare(b.label, "th")
  );

  const districtSet = new Set(
    data
      .filter(item => item?.provinceList?.[0])
      .filter(
        item => item?.provinceList?.[0]?.provinceName === selectedProvince
      )
      .map(item => item?.districtList?.map(district => district?.districtName))
      .flat()
  );
  const district = generateLabelValue(districtSet, "district").sort((a, b) =>
    a.label.localeCompare(b.label, "th")
  );

  const selectedDistrict = formik?.values?.district.replace(/^(เขต |อ\. )/, "");

  const currentProvince = data.filter(
    item =>
      item?.provinceList?.[0] &&
      item?.provinceList?.[0]?.provinceName === selectedProvince
  );

  const districtDetail = () => {
    for (const item of currentProvince) {
      const district = item.districtList.find(
        district => district.districtName === selectedDistrict
      );
      if (district) {
        return district;
      }
    }
    return null;
  };

  const mapSubDistrictsByDistrictId = () => {
    const result = [];
    const districtId = districtDetail()?.districtId || "";
    currentProvince.forEach(item => {
      const filteredSubDistricts = item.subDistrictList.filter(
        subDistrict => subDistrict.districtId === districtId
      );
      result.push(...filteredSubDistricts);
    });
    return result.map(item => item.subDistrictName);
  };

  const subDistrict = generateLabelValue(
    mapSubDistrictsByDistrictId(),
    "subDistrict"
  ).sort((a, b) => a.label.localeCompare(b.label, "th"));

  const selectedSubDistrict = formik?.values?.subDistrict.replace(
    /^(แขวง |ต\. )/,
    ""
  );
  const selectedZipCode =
    formik.values.postalCode ||
    getZipCode(selectedProvince, selectedDistrict, selectedSubDistrict);

  useEffect(() => {
    if (formik.values.countryCode === "TH") {
      if (selectedZipCode) {
        formik.setFieldValue("postalCode", selectedZipCode);
      } else {
        formik.setFieldValue("postalCode", "");
      }
    }
  }, [selectedZipCode]);

  // 'city' is referred to as 'province' here.
  return { subDistrict, district, city, zipCode, selectedZipCode };
};
export default useThailandAddress;
